import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CctvDtoKeysEnum } from '@zaoblako/shared/modules/cctv/enums/cctv-dto-keys.enum';
import { entityLikeSchema, entityLikeSchemaStrict } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import { nonEmptyStringSchema } from '@zaoblako/shared/modules/serde/schemas/non-empty-string.schema';
import { CctvCheckersEnum } from '@zaoblako/shared/modules/cctv/enums/cctv-checkers.enum';
import { CatalogCheckersEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-checkers.enum';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';
import { ClientCheckerKeysEnum } from '@zaoblako/shared/modules/client/enums/client-checker-keys.enum';
import type { CarCategoryFindInterface } from '@zaoblako/shared/modules/cctv/dtos/car-category/car-category-find.dto';
import type { ClientFindInterface } from '@zaoblako/shared/modules/client/dtos/client/client-find.dto';
import type { RoomFindInterface } from '@zaoblako/shared/modules/catalog/dtos/room/room-find.dto';

import  * as yup from 'yup';

/** Resident car request body */
export interface ResidentCarFormInterface {
  /** State registration number of the car */
  carNumber: string;
  /** Car category */
  category: CarCategoryFindInterface;
  /** Client who owns this car */
  client: ClientFindInterface;
  /** The rooms to which this car is granted access */
  rooms?: RoomFindInterface[];
}

/** Resident car request body - DTO schema */
export const ResidentCarFormDto = SerdeDtoClass.create<ResidentCarFormInterface>(CctvDtoKeysEnum.RESIDENT_CAR_FORM_DTO, {
  carNumber: {
    label: 'Номер ТС',
    serializer: nonEmptyStringSchema,
  },
  category: {
    label: 'Категория ТС',
    serializer: entityLikeSchemaStrict,
    checkers: [CctvCheckersEnum.CAR_CATEGORY_ASSERT_EXISTS_BY_DTO],
  },
  client: {
    label: 'Клиент',
    serializer: entityLikeSchemaStrict,
    checkers: [ClientCheckerKeysEnum.CLIENT_ASSERT_EXISTS_BY_DTO],
  },
  rooms: {
    label: 'Помещения',
    serializer: yup
      .array(entityLikeSchema)
      .min(1, DtoMessageEnum.EMPTY_ARRAY),
    checkers: [CatalogCheckersEnum.ROOM_ASSERT_EXISTS_BY_DTO],
  },
});
